import React from "react"
import Dialog from "../index"
import Text from "../../../../../../_components/Text"

export default props => {
    const handleCopy = () => {
        const text = `Código: ${props.code || "N/A"} — ${props.message}`
        navigator.clipboard.writeText(text)
    }

    return (
        <Dialog
            title="NF-e Rejeitada pela SEFAZ"
            type="warning"
            show={props.show}
            onHide={props.onClose}
        >
            {props.code && (
                <div className="d-flex justify-content-center mb-2">
                    <span className="badge badge-danger" style={{ fontSize: "1rem" }}>
                        Código de Rejeição: {props.code}
                    </span>
                </div>
            )}
            <Text color="primary" className="text-center">
                {props.message}
            </Text>
            <div className="d-flex justify-content-center mt-3" style={{ gap: "8px" }}>
                <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={handleCopy}
                    title="Copiar erro"
                >
                    <i className="fas fa-copy mr-1" /> Copiar erro
                </button>
                <button
                    className="btn btn-primary btn-sm"
                    onClick={props.onClose}
                >
                    Voltar e corrigir
                </button>
            </div>
        </Dialog>
    )
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Dialog/NFeRejeited/index.jsx